import axios from "axios";
import { filtersURL } from "@/utilities/filtersURL";

export const fetchPaidRecords = {
  async fetchPaidRecords({ commit }, { storeId, filters, limiter, page }) {
    let generatedFiltersURL = filtersURL.generate(filters);

    try {
      const response = await axios.get(`stores/payout/all-payout-data/${storeId}?${generatedFiltersURL}`, {
        params: {
          limiter,
          page
        }
      });

      const { current_page, last_page, next_page_url, previous_page_url, total } = response.data;
      const pagination = {
        current_page,
        last_page,
        next_page_url,
        previous_page_url,
        total_count: total,
        per_page: limiter
      }

      commit('SET_PAID_RECORDS', response.data.payouts || []);
      commit('SET_PAID_RECORDS_PAGINATION', pagination);
    } catch(error) {
      console.log(error);
    }
  }
};
